// {"call":"range_history_all","data":{"network":"signet","start_timestamp":1713832677,"end_timestamp":1745368677}}

import { Network } from '@/lib/networkConfig';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from './query-keys';
import { post } from './api.helpers';
import { HistoryPagedResponse } from './api.types';
import { VALIDATOR_URL } from '@/constants';
import { actionMap } from './useQueryOverviewHistory';
import { VaultTransaction } from './types';

const url = `${VALIDATOR_URL}/api/vault_history_tx`;

export function formatVaultHistory(response: HistoryPagedResponse<VaultTransaction>) {
  return response.history?.map((item) => ({
      ...item,
      //@ts-ignore
      action: actionMap[item.action] || item.action,
    })) || []
}

export async function fetchVaultHistory(vaultTxId: string) {
  const now = Math.floor(Date.now() / 1000);
  const oneYearInSeconds = 365 * 24 * 60 * 60;
  const params = {
    vault_id: vaultTxId,
    timestamp_start: now - oneYearInSeconds,
    timestamp_end: now,
    pagination: {
      limit: 250,
      offset: 0,
    },
  };
  const response: HistoryPagedResponse<VaultTransaction> = await post(
    url,
    params
  );

  return formatVaultHistory(response);
}

// Note: validator's term "vault id" is the vault transaction id (clientsdk vault id but without "i1" in the end).
export function useQueryVaultHistory(
  vaultTxId: string | undefined,
  options = {}
) {
  // const vaultTxId2 = 'bd07ee953729acf0c67cd63833e7344985541f94b5e1b51d80e73a466f62ea40'; // 249txs
  // const vaultTxId3 = '88a5fd8b08c20bd302b6653ff24f52c905b27c5c2cb39e00899330dfd24eb955' // 486txs
  // vaultId = vaultTxId2;

  return useQuery<VaultTransaction[]>({
    queryKey: [QueryKeys.vaultHistory, vaultTxId],
    queryFn: async () => {
      if (!vaultTxId) {
        throw Error('No vault id provided');
      }
      return fetchVaultHistory(vaultTxId);
    },
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error: any) => {
      if (failureCount >= 5) return false;
      // Note: tanstack does not retry for 404, so we manually force it.
      if (error?.status === 404) return true;
      return true;
    },
    retryDelay: 3000,
    enabled: !!vaultTxId,
    ...options,
  });
}
